import { render, staticRenderFns } from "./fundCenter.vue?vue&type=template&id=a787d84c&scoped=true"
import script from "./fundCenter.vue?vue&type=script&lang=js"
export * from "./fundCenter.vue?vue&type=script&lang=js"
import style0 from "./fundCenter.vue?vue&type=style&index=0&id=a787d84c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a787d84c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a787d84c')) {
      api.createRecord('a787d84c', component.options)
    } else {
      api.reload('a787d84c', component.options)
    }
    module.hot.accept("./fundCenter.vue?vue&type=template&id=a787d84c&scoped=true", function () {
      api.rerender('a787d84c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fund/fundCenter.vue"
export default component.exports